/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The ChartsDataRevenue model module.
* @module model/ChartsDataRevenue
* @version 1.0.0
*/
export default class ChartsDataRevenue {
    /**
    * Constructs a new <code>ChartsDataRevenue</code>.
    * @alias module:model/ChartsDataRevenue
    * @class
    * @param revenue {Number} 
    * @param expenses {Number} 
    * @param profit {Number} 
    */

    constructor(revenue, expenses, profit) {
        

        
        

        this['revenue'] = revenue;this['expenses'] = expenses;this['profit'] = profit;

        
    }

    /**
    * Constructs a <code>ChartsDataRevenue</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ChartsDataRevenue} obj Optional instance to populate.
    * @return {module:model/ChartsDataRevenue} The populated <code>ChartsDataRevenue</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ChartsDataRevenue();

            
            
            

            if (data.hasOwnProperty('revenue')) {
                obj['revenue'] = ApiClient.convertToType(data['revenue'], 'Number');
            }
            if (data.hasOwnProperty('expenses')) {
                obj['expenses'] = ApiClient.convertToType(data['expenses'], 'Number');
            }
            if (data.hasOwnProperty('profit')) {
                obj['profit'] = ApiClient.convertToType(data['profit'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} revenue
    */
    revenue = undefined;
    /**
    * @member {Number} expenses
    */
    expenses = undefined;
    /**
    * @member {Number} profit
    */
    profit = undefined;








}


